/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Preference_AvoidInputs */

const en_us2_exercise_personal_preference_avoid = /** @type {(inputs: Exercise_Personal_Preference_AvoidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I'd rather avoid`)
};

const pt_br2_exercise_personal_preference_avoid = /** @type {(inputs: Exercise_Personal_Preference_AvoidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefiro evitar`)
};

const es_419_exercise_personal_preference_avoid = /** @type {(inputs: Exercise_Personal_Preference_AvoidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefiero evitarlo`)
};

const pt_pt2_exercise_personal_preference_avoid = /** @type {(inputs: Exercise_Personal_Preference_AvoidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefiro evitar`)
};

const fr_fr2_exercise_personal_preference_avoid = /** @type {(inputs: Exercise_Personal_Preference_AvoidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je préfère éviter`)
};

const de_de2_exercise_personal_preference_avoid = /** @type {(inputs: Exercise_Personal_Preference_AvoidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lieber nicht`)
};

const it_it2_exercise_personal_preference_avoid = /** @type {(inputs: Exercise_Personal_Preference_AvoidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferisco evitarlo`)
};

/**
* | output |
* | --- |
* | "I'd rather avoid" |
*
* @param {Exercise_Personal_Preference_AvoidInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_preference_avoid = /** @type {((inputs?: Exercise_Personal_Preference_AvoidInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Preference_AvoidInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_preference_avoid(inputs)
	if (locale === "es-419") return es_419_exercise_personal_preference_avoid(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_preference_avoid(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_preference_avoid(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_preference_avoid(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_preference_avoid(inputs)
	return en_us2_exercise_personal_preference_avoid(inputs)
});
export { exercise_personal_preference_avoid as "exercise-personal.preference_avoid" }